<template>
  <div class="member-card">
    <div class="card-header">
      <img class="header-logo" src="@/assets/img/share/auth/logo.png" alt="">
    </div>
    <div class="card-content">
      <!-- 课题组组长 {{info.headName}} -->
      <div class="content-title">尊敬的{{info.groupName}}PI/联系人{{info.leaderName}}您好：</div>
      <div class="content-tip">以下是您课题组中未授权的成员，为保证不影响贵方业务，请您为其进行授权</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss" scoped>
.member-card {
  min-height: 20vh;
  background-image: url('~@/assets/img/share/auth/card_bg.png');
  background-size: cover;
  border-radius: 0 0 4px 4px;
  .card-header {
    display: flex;
    align-items: center;
    width: 100%;
    height: 5vh;
    padding-left: 20px;
    border-radius: 4px 4px 0 0;
    background-color: #0b489b;
    .header-logo {
      width: 70px;
    }
  }
  .card-content {
    padding: 15px;
    font-size: 12px;
    color: #4c4c4c;
    .content-title {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 7px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/share/member-auth/components/MemberCard.vue